/**
 * @fileoverview POST handler for "/apps/:app_group_id/user_imports/:import_id/initialize_map"
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdInitializeMapCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdUserImportsImportIdInitializeMapProps,
  PostAppsAppGroupIdUserImportsImportIdInitializeMapResult,
} from "./types";

const DATA_MAPPER_MUTATION_FETCH_SETTINGS = {
  propagateFetchRequestError: false,
};

export const postAppsAppGroupIdUserImportsImportIdInitializeMap = reactQueryMutationAdapter(
  appsAppGroupIdUserImportsImportIdInitializeMapCacheKeys,
  ({
    appGroupId,
    importId,
    dataMapId,
  }: PostAppsAppGroupIdUserImportsImportIdInitializeMapProps): Promise<PostAppsAppGroupIdUserImportsImportIdInitializeMapResult> => {
    const body: Record<string, string> = {};
    if (dataMapId != null && dataMapId !== "") {
      body.data_map_id = dataMapId;
    }

    return fetch(
      `/apps/${appGroupId}/user_imports/${importId}/initialize_map`,
      "POST",
      body,
      {},
      DATA_MAPPER_MUTATION_FETCH_SETTINGS
    );
  }
);
